/** Bulk-create drafts are not scoped to a shop. Clear them when access changes. */
export const DRAFT_STORAGE_KEY = "riverr.bulkCreate.planner.v1";
export const WIZARD_STORAGE_KEY = "riverr.bulkCreate.wizard.v1";
export const WIZARD_SESSION_KEY = "riverr.bulkCreate.wizard.session.v1";

export function dropUnscopedBulkCreateDrafts() {
  try {
    localStorage.removeItem(DRAFT_STORAGE_KEY);
    localStorage.removeItem(WIZARD_STORAGE_KEY);
    sessionStorage.removeItem(WIZARD_SESSION_KEY);
  } catch {
    /* private mode */
  }
}
